/**
 * The response from the ipify API.
 * 
 * @see https://www.ipify.org/
 */
type IpifyResponse = {
  ip: string;
};

/**
 * Fetches the user IP address from the ipify API.
 * 
 * @returns The user IP address or undefined if the request fails.
 */
export async function getUserIpFromIpify(): Promise<string | undefined> {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    if (!response.ok) {
      throw new Error('Failed to fetch user IP from ipify');
    }
    const data = await response.json() as IpifyResponse;
    if ('ip' in data) {
      return data.ip;
    }
  } catch (error) {
    console.error('Failed to fetch user IP from ipify:', error);
    return undefined;
  }
  return undefined;
}